// eslint-disable-next-line no-redeclare,no-unused-vars
function setTitle(value, changeTitleCache) {
    $('#systemInfo').text(value);
    if (changeTitleCache) window.title = value;
    if (localStorage.getItem('mute')) value = "\u263E " + value;
    document.title = value;
}

//# sourceMappingURL=index.d136b2ca.js.map
